import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LeadPopup from "./LeadPopup";
import CookieBanner from "./CookieBanner";
import MetaPixel from "./MetaPixel";
import WhatsAppButton from "./WhatsAppButton";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <LeadPopup />
      <CookieBanner />
      <MetaPixel />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
